<template>
  <div class="progress-bar" :style="{height: `${height}px`}">
    <div class="progress-stream" :style="{width: `${value}%`, height: `${height}px`}"></div>
    <div class="progress-content">
      <slot>
        <strong>{{ Math.ceil(value) }}%</strong>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-progress-bar',
  props: {
    value: {
      type: Number,
    },
    height: {
      type: [Number, String],
      default: 25,
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-bar {
  width: 100%;
  background-color: $gray;
  position: relative;
}
.progress-stream {
  width: 0%;
  background-color: #1c519c;
}
.progress-content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  color: white;
}
</style>
